<script setup>
import { CdrText, CdrLink, CdrBanner, IconWarningFill } from '@rei/cedar';
import { useReservationsStore } from '../../stores/day-cancellation/reservations';
import { useDepartureStore } from '../../stores/day-cancellation/departure';
import cms from './data';

const reservations = useReservationsStore();
const departure = useDepartureStore();
</script>

<template>
  <div class="payment-message">
    <CdrBanner
      v-if="reservations.isNotRefundable && !departure.isFree"
      class="payment-message__warning"
      type="warning"
      data-ui="payment-message-warning"
    >
      <template #icon-left>
        <IconWarningFill />
      </template>
      <div class="payment-message__not-eligible">
        <strong>Not eligible for a refund.</strong>
        Because this event is in
        <strong>{{ departure.daysToStart }},</strong>
        it is outside of our
        <CdrLink
          class="payment-message__policy"
          href="https://www.rei.com/events/resources/cancellation#refund-policy"
          target="_blank"
          data-analytics-id="day-cancellation:PaymentMessage_refund policy"
        >
          fully refundable cancellation period.
        </CdrLink>
      </div>
    </CdrBanner>
    <CdrText
      v-if="!reservations.isNotRefundable && !departure.isFree"
      class="payment-message__refund"
      data-ui="payment-message-refund"
    >
      {{ cms.selectReservations.paymentMessage.refund }}
    </CdrText>
  </div>
</template>

<style lang="scss" scoped>
@import '@rei/cdr-tokens/dist/rei-dot-com/scss/cdr-tokens.scss';

.payment-message {
  &__refund {
    @include cdr-text-body-300;
  }

  &__warning {
    padding-top: $cdr-space-two-x;
  }

  &__refund,
  &__warning {
    max-width: 400px;
  }

  &__not-eligible {
    padding-top: $cdr-space-half-x;
    padding-bottom: $cdr-space-half-x;
  }

  &__policy {
    display: inline;
  }
}
</style>
